export const DIALOG_SHIPMENT_REQUEST_DETAILS = {
   COMPLETE_DATE_FORMAT: 'dd/MMM/yyyy \'a\' \'las\' h:mm a',
   DATE_FORMAT: 'DD/MM/yyyy',
   TIME_FORMAT: 'h:mm a',
   GEOLOCATION: 'geolocation',
   ZOOM: 20
};
